import React from 'react';
import { ThemeProvider as MuiThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { createLightTheme, createDarkTheme } from './muiTheme';
import { ThemeContextProvider } from '../contexts/ThemeContext';
import { useTheme } from '../hooks/useTheme';

// Inner component that uses the theme context
const ThemedMuiProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { isDark } = useTheme();
  const theme = isDark ? createDarkTheme() : createLightTheme();

  return (
    <MuiThemeProvider theme={theme}>
      <CssBaseline />
      {children}
    </MuiThemeProvider>
  );
};

interface ThemeProviderProps {
  children: React.ReactNode;
}

export const ThemeProvider: React.FC<ThemeProviderProps> = ({ children }) => {
  return (
    <ThemeContextProvider>
      <ThemedMuiProvider>
        {children}
      </ThemedMuiProvider>
    </ThemeContextProvider>
  );
};
